export default __webpack_public_path__ + "static/media/iconHomePaperActive.a65c7724.svg";